import { render, staticRenderFns } from "./FeaturedArtists.vue?vue&type=template&id=46767371"
import script from "./FeaturedArtists.vue?vue&type=script&lang=js"
export * from "./FeaturedArtists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports